
const C = {
    AMBIANCE_PHASE: "ambiance",
    FOOD_DRINK_PHASE: "foodDrink",
    NUM_VIDS_PER_PHASE: 3,
}

export default C;